import styled from 'styled-components'
import logo from './../../assets/logo.png';

export const LayoutStyle = styled('div')`
  width: 100%;
  min-height: 100%;
  display: flex;
  .menu{
    width: 200px;
    overflow: hidden;
    .logo{
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #eee;
      background: url(${logo}) 20px no-repeat;
      background-size: 50%;
    }
  }
  .content{
    background: #F0F2F5;
    flex: 1;
    overflow: hidden;
    .box{
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .header{
      flex: 0 0 auto;
      height: 50px;
      border-bottom: 1px solid #eee;
    }
    .main{
      padding: 10px;
      flex-grow: 1;
      .ant-breadcrumb{
        flex: 0 0 auto;
        padding: 0 15px;
        background: #fff;
        height: 50px;
        line-height: 50px;
      }
      .ant-layout-content{
        flex-grow: 1;
        margin-top: 10px;
      }
    }
  }
`